/** @jsxImportSource @emotion/react */

import * as S from './styles';

import React, { useRef } from 'react';

import Portal from '../portal/portal';
import { SerializedStyles } from '@emotion/react';
import UDText from '../text';
import { X } from 'lucide-react';
import classNames from 'classnames';
import { theme } from 'styles/theme/theme';

type DivProps = Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'children'> & {
  css?: SerializedStyles;
};

export type UDModalProps = {
  show: boolean;
  children: React.ReactNode | React.ReactNode[];
  header?: {
    title: string;
    subtitle: string;
  };
  overlayProps?: DivProps;
  containerProps?: DivProps;
  closeIconProps?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
  onClose?: React.MouseEventHandler<HTMLElement>;
};

const UDModal = (props: UDModalProps) => {
  const nodeRef = useRef(null);

  if (!props.show) {
    return null;
  }

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    // Проверяем, что клик был именно по оверлею, а не по контенту
    if (event.target === event.currentTarget && props.onClose) {
      props.onClose(event);
    }
  };

  return (
    <Portal wrapperId="portal_modal_container">
      <S.ModalOverlay
        {...props.overlayProps}
        className={classNames('d-flex align-items-center justify-content-center', props.overlayProps?.className)}
        onClick={handleOverlayClick}
      >
        <S.ModalContainer
          {...props.containerProps}
          className={classNames('px-10 pb-8 pt-6', props.containerProps?.className)}
          ref={nodeRef}
        >
          <div className="c-pointer close flex-center px-10 py-6" onClick={props.onClose}>
            <X size={24} className="modal-close-icon" color={theme.colors.SurfaceRomanSilver30} />
          </div>
          {props.header && (
            <>
              <UDText type="headline" className="color-SurfaceWhite center mb-4">
                {props.header.title}
              </UDText>
              <UDText type="callout" className="color-SurfaceRomanSilver30 center">
                {props.header.subtitle}
              </UDText>
            </>
          )}
          {props.children}
        </S.ModalContainer>
      </S.ModalOverlay>
    </Portal>
  );
};

export default UDModal;
